<template>
  <slo-modal :maxWidth="720" v-if="authenticated" @formSubmit="handleShare()" @dismiss="cancel()" class="share-project-modal">
    <template v-slot:title>
      {{ 'Share' | t }} <strong v-html="(project || initialProject).name" /> {{ 'Spec' | t }}
    </template>
    <section v-stack-y:lg v-if="!sharing">
      <slo-field>
        <slo-label>{{ 'Add Recipients' | t }}</slo-label>
        <ul>
          <li v-for="email in emails" :key="email">{{ email }}</li>
        </ul>
        <slo-input
          ref="email"
          type="email"
          name="email"
          v-model="currentEmail"
          :placeholder="'Enter email address' | t"
          @tab="addEmail($event)"
          @enter="addEmail($event)"
        />
      </slo-field>
      <slo-field>
        <slo-textarea
          name="message"
          v-model="message"
          :placeholder="'Add a message for your recipients (optional)' | t"
        />
      </slo-field>
    </section>
    <section v-else>
      <p>{{ 'Sharing...' | t }}</p>
    </section>
    <template v-slot:footer>
      <slo-button fill="outline" @click="cancel()">{{ 'Cancel' | t }}</slo-button>
      <slo-button type="submit">{{ 'Share' | t }}</slo-button>
    </template>
  </slo-modal>
  <slo-modal :maxWidth="640" v-else @dismiss="cancel()" @formSubmit="submit()" :form="false">
    <template v-slot:title>
      {{ 'Share' | t }} <strong v-html="(project || initialProject).name" /> {{ 'Spec' | t }}
    </template>
    <section v-stack-y:lg>
      <p>{{ 'To share your custom Sloan DesignSpec, log in or create an account.' | t }}</p>
      <slo-auth />
    </section>
  </slo-modal>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {shareProject} from '../../apis/designspec';
import SloModal from '../../../../lib/components/SloModal.vue';
import SloField from '../../../../lib/components/SloField.vue';
import SloInput from '../../../../lib/components/SloInput.vue';
import SloLabel from '../../../../lib/components/SloLabel.vue';
import SloAuth from '../../../../lib/components/SloAuth.vue';
import SloButton from '../../../../lib/components/SloButton.vue';
import SloTextarea from '../../../../lib/components/SloTextarea.vue';
import t from '../../../main/i18n';

export default {
  components: {
    SloModal,
    SloField,
    SloInput,
    SloLabel,
    SloAuth,
    SloButton,
    SloTextarea
  },
  async beforeRouteLeave(to, from, next) {
    if (this.isCreating) return;

    const wasLoggedIn = this.initialAuthenticated;
    const isLoggedIn = this.authenticated;
    if (!wasLoggedIn && isLoggedIn) {
      this.isCreating = true;
      const project = this.initialProject;
      project.id = null;
      const id = await this.createProject(project);
      this.isCreating = false;
      this.initialAuthenticated = true;
      return next(`/designspec/project/${id}/share`);
    }
    next();
  },
  mounted() {
    this.initialAuthenticated = this.authenticated;
    this.$nextTick(() => {
      this.initialProject = this.project || {name: ''};
    });
  },
  data() {
    return {
      isCreating: false,
      initialProject: {},
      initialAuthenticated: false,
      sharing: false,
      emails: [],
      currentEmail: '',
      message: ''
    };
  },
  filters: {
    t
  },
  watch: {
    project(to) {
      if (to && to.id) {
        const input = this.$refs.email;
        input && input.setFocus();
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['authenticated']),
    ...mapGetters('designspec', {getProject: 'project'}),
    project() {
      return this.getProject(Number(this.$route.params.id));
    }
  },
  methods: {
    ...mapActions('designspec', ['createProject']),
    async handleAuthenticationSwitch() {
      const project = this.project;
      if (project) {
        project.id = null;
        const id = await this.createProject(project);
        return `/designspec/project/${id}`;
      }
      return '/designspec/projects';
    },
    addEmail(event) {
      if (this.currentEmail) {
        event.preventDefault();
        this.emails = [...this.emails, this.currentEmail];
        this.currentEmail = '';
      }
    },
    cancel() {
      this.$router.replace(`/designspec/project/${this.project.id}`);
    },
    submit() {
    },
    async handleShare() {
      const project = this.project;
      if (this.sharing) return;
      this.sharing = true;
      const emails = [...this.emails, this.currentEmail].filter(v => v);
      const message = this.message;
      shareProject(this.project.id, {emails, message}).then(res => {
        if (res.shared) {
          this.$root.$emit('designspec:share', project);
        }
        this.sharing = false;
      });
      await this.$router.replace(`/designspec/project/${this.project.id}`);
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../../../scss/variables';
</style>
